<template>
  <v-form ref="form" class="">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />
    
    <v-row>

      <v-col cols="12" sm="12" md="8">
        <v-autocomplete
          v-model="entry.stockAdjustmentReasonId"
          v-bind="getObject('stockAdjustmentReasonId')"
          label="Motivo do Ajuste de Estoque"
          :items="extraData.accountContext.allStockAdjustmentReasons"
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          autocomplete="off"
        >
          <template v-slot:append-outer>
            <StockAdjustmentReasonNew
              :inlineAddButton="true"
              @entry-created="stockAdjustmentReasonCreated"
              modelNameSingular="Motivo do Ajuste de Estoque"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="8" md="4">
        <v-switch 
          v-model="entry.isStockEntryType" 
          inset 
          :label="entry.isStockEntryType ? 'Entrada em Estoque' : 'Saída de Estoque'"
          :disabled="readOnly">
        </v-switch>
      </v-col>

      <v-col cols="12" sm="10" md="8">
        <v-autocomplete
          v-model="entry.stockId"
          v-bind="getObject('stockId')"
          label="Estoque"
          :items="extraData.accountContext.allStocks"
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          autocomplete="off"
        >
          <template v-slot:append-outer>
            <StockNew
              :inlineAddButton="true"
              @entry-created="stockCreated"
              modelNameSingular="Estoque"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <DateField
          :inputData.sync="entry.date"
          v-bind="getObject('date')"
          label="Data do Ajuste"
          :hasTodayButton="true"
          :hasTodayDate="true"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" class="" v-if="entry.stockId && entry.isStockEntryType">
        <StockAdjustmentItemsIndex
          :stockAdjustmentItems="entry.stockAdjustmentItemsAttributes"
          :stockAdjustment="entry"
          :readOnly="readOnly"
          :isEdit="isEdit"
        />
      </v-col>

       <v-col cols="12" class="" v-if="entry.stockId && !entry.isStockEntryType">
        <StockAdjustmentConsumedItemsIndex
          :consumedItems="entry.consumedItemsAttributes"
          :stockAdjustment="entry"
          :readOnly="readOnly"
          :isEdit="isEdit"
        />
      </v-col>

      <v-col cols="12">
        <v-textarea
          v-model="entry.description"
          v-bind="getObject('description')"
          label="Observações"
          outlined
          autocomplete="off"
          :disabled="readOnly"
        ></v-textarea>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue";
import StockAdjustmentItemsIndex from "@models/stocks/stock_adjustments/stock_adjustment_items/index.vue";
import StockNew from "@models/stocks/new.vue"
import StockAdjustmentReasonNew from "@models/stocks/stock_adjustments/stock_adjustment_reasons/new.vue"
import StockAdjustmentConsumedItemsIndex from "@models/stocks/stock_adjustments/stock_adjustment_consumed_items/index.vue";
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    StockAdjustmentItemsIndex: StockAdjustmentItemsIndex,
    StockNew: StockNew,
    StockAdjustmentReasonNew: StockAdjustmentReasonNew,
    StockAdjustmentConsumedItemsIndex: StockAdjustmentConsumedItemsIndex,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    stockCreated: function(stock) {
      this.extraData.accountContext.allStocks.unshift(stock);
      this.entry.stockId = stock.id;
      this.entry.stock = stock;
    },
    stockAdjustmentReasonCreated: function(stockAdjustmentReason) {
      this.extraData.accountContext.allStockAdjustmentReasons.unshift(stockAdjustmentReason);
      this.entry.stockAdjustmentReasonId = stockAdjustmentReason.id;
      this.entry.stockAdjustmentReason = stockAdjustmentReason;
    },
  }
};
</script>

<style scoped></style>
